import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";
import styled from "styled-components";
import connectComponent from "redux/connectComponent";
import * as Toast from "screens/shared/toast";
import SectionHeading from "components/sectionHeading";

const Wrap = styled.div`
  ${tw`w-full mx-auto px-[15px]`}
  max-width: 1140px;
`;
const FormGroup = styled.div`
  ${tw`mb-4`}
`;
const FormInput = styled.input`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;

  &:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
`;
const ButtonRow = styled.div`
  ${tw`flex flex-wrap justify-center text-center my-4`}
`;
const OutlineSuccessButton = styled.button`
  ${tw`inline-block font-normal text-center cursor-pointer`}
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  color: #28a745;
  background-color: transparent;
  border: 1px solid #28a745;
  transition: all 0.15s ease-in-out;

  &:hover {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }
`;

class Confirmation extends React.PureComponent {
  static propTypes = {
    actions: PropTypes.object
  };

  state = {
    confirmed: false,
    error: null
  };

  constructor(props) {
    super(props);
    this.emailRef = React.createRef();
  }

  resend = (event) => {
    event.preventDefault();
    this.props.actions
      .resendConfirmation(this.emailRef.current.value)
      .then(() => this.setState({ confirmed: true }))
      .catch(() => {
        Toast.createToast("Email does not need confirmation", { color: "red" });
      });
    return false;
  };

  render() {
    if (this.state.confirmed)
      return (
        <Wrap>
          <SectionHeading>
            Check your email for a confirmation link
          </SectionHeading>
        </Wrap>
      );

    return (
      <React.Fragment>
        <Wrap>
          <SectionHeading>Resend confirmation instructions</SectionHeading>
        </Wrap>

        <Wrap>
          <form action="/" onSubmit={this.resend}>
            <FormGroup>
              <label htmlFor="email">Email</label>
              <FormInput
                name="email"
                id="email"
                ref={this.emailRef}
                autoFocus={true}
                autoComplete="email"
                required="required"
              />
            </FormGroup>

            <ButtonRow>
              <OutlineSuccessButton
                type="submit"
                name="commit"
                data-testid="resend"
              >
                Resend
              </OutlineSuccessButton>
            </ButtonRow>
            <br />
          </form>
        </Wrap>
      </React.Fragment>
    );
  }
}
export default connectComponent(Confirmation, []);
